import { create } from 'zustand'

interface TabNotificationsState {
  jobs: boolean
  skills: boolean
  setJobsNotification: (value: boolean) => void
  setSkillsNotification: (value: boolean) => void
}

export const useTabNotificationsStore = create<TabNotificationsState>((set) => ({
  jobs: false,
  skills: false,
  setJobsNotification: (value) => set({ jobs: value }),
  setSkillsNotification: (value) => set({ skills: value }),
}))
